import { SearchBar as MerchSearchBar } from '@carvana/merch-search-bar/index';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import MobileFilters from '@/srp/MainLayout/MobileFilters';
import { SearchInputWrapper } from '@/srp/MainLayout/SearchHeader/SearchHeader.styles';
import SearchSource from '~/constants/srp/SearchSource';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useSearchSource } from '~/context/srp/SearchEventsDataContext';
import useSearchBarProps from '~/hooks/srp/useSearchBarProps';

const SearchBarModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "SearchBarModal" */ '@/srp/Modals/SearchBarModal'
    ),
  { ssr: false }
);

type OwnProps = {
  isStickySearchBar: boolean;
};

const shouldClearInput = (searchSource: SearchSource) => {
  switch (searchSource) {
    case SearchSource.DefaultSuggestion:
    case SearchSource.RecentSearch:
    case SearchSource.SavedSearch:
    case SearchSource.TextSearch:
      return false;
    default:
      return true;
  }
};

export default function SearchBar({ isStickySearchBar }: OwnProps) {
  const isMobile = useIsMobile();
  const searchBarProps = useSearchBarProps();
  const [inputValue, setInputValue] = useState('');
  const searchSource = useSearchSource();

  useEffect(() => {
    if (shouldClearInput(searchSource)) {
      setInputValue('');
    }
  }, [searchSource]);

  return (
    <SearchInputWrapper>
      <MerchSearchBar
        inputValue={inputValue}
        setInputValue={setInputValue}
        {...searchBarProps}
      />
      <MobileFilters isStickySearchBar={isStickySearchBar} />
      {isMobile && (
        <SearchBarModal
          inputValue={inputValue}
          setInputValue={setInputValue}
          {...searchBarProps}
        />
      )}
    </SearchInputWrapper>
  );
}
